import { render, staticRenderFns } from "./HeaderList.vue?vue&type=template&id=49c4e690&"
import script from "./HeaderList.vue?vue&type=script&lang=ts&"
export * from "./HeaderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports